import { Separator } from "@/components/ui/separator"

import { Plan } from "../../types"

interface PlanSummaryProps {
  selectedPlan: Plan | null
}

export function PlanSummary({ selectedPlan }: PlanSummaryProps) {
  return (
    <div className="border-r border-gray-100 bg-gray-50 p-8 dark:border-gray-800 dark:bg-gray-900">
      <div className="mx-auto max-w-md">
        <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100">Resumo do Pedido</h2>
        <p className="mb-6 text-sm text-gray-500 dark:text-gray-400">
          Confira os detalhes da sua assinatura
        </p>

        <div className="mb-6">
          <div className="flex items-center">
            <span className="flex-1 text-lg font-medium">
              {selectedPlan?.interval === "yearly" ? "Plano Anual" : "Plano Mensal"}
            </span>
          </div>
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">ID: {selectedPlan?.id}</p>
        </div>

        <div className="mb-6 space-y-3">
          <div className="flex justify-between text-sm">
            <span className="text-gray-600 dark:text-gray-400">Preço</span>
            <span>{selectedPlan?.formattedPrice}</span>
          </div>

          <div className="flex justify-between text-sm">
            <span className="text-gray-600 dark:text-gray-400">Período</span>
            <span>{selectedPlan?.interval === "yearly" ? "Anual" : "Mensal"}</span>
          </div>

          {selectedPlan?.interval === "yearly" && (
            <div className="flex justify-between text-sm">
              <span className="text-gray-600 dark:text-gray-400">Economia anual</span>
              <span className="text-green-600 dark:text-green-400">25%</span>
            </div>
          )}
        </div>

        <Separator className="my-6" />

        <div className="mb-6 flex justify-between">
          <span className="text-base font-medium">Total</span>
          <span className="text-base font-medium">{selectedPlan?.formattedPrice}</span>
        </div>

        <div className="text-xs text-gray-500 dark:text-gray-400">
          Ao assinar, você concorda com nossos{" "}
          <a href="/legal/terms.html" target="_blank" className="text-primary underline">
            Termos de Serviço
          </a>{" "}
          e{" "}
          <a href="/legal/privacy-policy.html" target="_blank" className="text-primary underline">
            Política de Privacidade
          </a>
          .
        </div>
      </div>
    </div>
  )
}
